/**
 * One choice among several, the prototype's «Velg et forslag» row (assistant.css .ar-option): white,
 * a radio on the left, the title in bold, grey lines under it; the chosen row tinted blue with a blue
 * border, the whole row the target. The planning panel's alternatives and bases and the shift
 * editor's «Hugin foreslår» use this one row, so they look the same.
 */
import type { ReactNode } from 'react';
import css from './planning.module.css';

export function OptionRow({
  name,
  value,
  checked,
  onChange,
  title,
  aside,
  tag,
  children,
  testid,
}: {
  /** the radio group's name */
  name: string;
  value: string;
  checked: boolean;
  onChange: () => void;
  title: ReactNode;
  /** right of the title, a price or a count */
  aside?: ReactNode;
  /** a small blue tag after the title, «Best egnet» */
  tag?: string | undefined;
  /** the grey lines under the title */
  children?: ReactNode;
  testid?: string;
}) {
  return (
    <label className={css.option} data-testid={testid}>
      <input type="radio" name={name} value={value} checked={checked} onChange={onChange} />
      <span className={css.optionCopy}>
        <span className={css.optionTitle}>
          <b>
            {title}
            {tag && <span className={css.bestTag}>{tag}</span>}
          </b>
          {aside != null && <strong>{aside}</strong>}
        </span>
        {children}
      </span>
    </label>
  );
}
